import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import axios from "axios";
import { Alert, Form, Input, Modal, Spin } from "antd";
import { axiosErrorHandler, isConcurrentModificationError } from "../../../../swzutils";
const ConsignmentInstructionsPatchModal = (props) => {
    const formRef = React.useRef(null);
    const [stateSaving, setStateSaving] = React.useState(false);
    const [stateErrorMessage, setStateErrorMessage] = React.useState(null);
    useEffect(() => {
        formRef.current?.setFieldsValue({
            instructions: props.consignment?.instructions
        });
    }, [props.consignment?.instructions]);
    const errorHandler = (errorMessage) => {
        setStateErrorMessage(errorMessage);
    };
    const onFinish = (formValues) => {
        patchInstructions(formValues.instructions);
    };
    const patchInstructions = (instructions) => {
        setStateSaving(true);
        axios.patch(`/admin/v1/consignments/${props.consignment?.id}`, {
            instructions: instructions,
            version: props.consignment?.version
        }).then(response => {
            props.onInstructionsUpdated(response.data);
        }).catch(error => {
            if (isConcurrentModificationError(error)) {
                errorHandler("The instructions could not be updated. This is because another user has updated the same consignment.  Please refresh the consignment list and try again.");
            }
            else {
                axiosErrorHandler(error, errorHandler);
            }
        }).finally(() => {
            setStateSaving(false);
        });
    };
    return (_jsx(Modal, { title: "Update Instructions", open: props.open, onOk: () => formRef.current.submit(), onCancel: props.onCancel, confirmLoading: stateSaving, destroyOnHidden: true, children: _jsxs(Spin, { spinning: stateSaving, children: [_jsx(Form, { layout: "vertical", ref: formRef, onFinish: onFinish, children: _jsx(Form.Item, { name: "instructions", label: "Instructions", initialValue: props.consignment && props.consignment.instructions, children: _jsx(Input.TextArea, { rows: 10 }) }) }), stateErrorMessage ? _jsx("div", { style: { marginTop: "20px" }, children: _jsx(Alert, { type: "error", title: stateErrorMessage, banner: true }) }) : null] }) }));
};
export default ConsignmentInstructionsPatchModal;
